export const getGaClientId = (): string | null => {
  if (typeof document === 'undefined') return null

  const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : null
}

export const appendGaToUrl = (url: string): string => {
  const gaClientId = getGaClientId()
  if (!gaClientId) return url

  try {
    const parsed = new URL(url)
    parsed.searchParams.set('_ga', gaClientId)
    return parsed.toString()
  } catch {
    return url
  }
}